module.exports = __webpack_public_path__ + "img/vf1.c7f2d83f.png";